module.exports = __webpack_public_path__ + "img/orange_071.a45afaa4.png";